import { render, staticRenderFns } from "./DeliverySection.vue?vue&type=template&id=32b87545&scoped=true&"
import script from "./DeliverySection.vue?vue&type=script&lang=js&"
export * from "./DeliverySection.vue?vue&type=script&lang=js&"
import style0 from "./DeliverySection.vue?vue&type=style&index=0&id=32b87545&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32b87545",
  null
  
)

export default component.exports